var res = "iphone-device";
var userAgent = navigator.userAgent.toLowerCase();
var Android = userAgent.indexOf("android") > -1;
  
if(Android) {
  res = "android-device";
}

var hpThemeDark = false;

var activeFilters = [];
var seriesFilters = [];

var updateNavButtonsPosition;
var carouselCaption;

var mobileLandscape = false;
var isScrolling;
var isScrollingDrawer;
var headerFooterHidden = false;
var angle = 0;

(function ($) {

  'use strict';

  var apparatus = {
    /**
     * Init Function
     */
    init: function () {

      $('.trade-form-pdp').on('submit', function() {
        gtag('event','trade_application_submit');
      });

      $('.inquiry-form-pdp').on('submit', function() {
        gtag('event','inquire_submit');
      })

      $('.subnav a, .nav-item a, .footer__nav a').on('click', function() {
        if($(this).attr('href') == '/pages/contact-us') {
          gtag('event', 'contact_click');
        }
        if($(this).attr('href') == '/pages/stockists') {
          gtag('event', 'locate_a_gallery');
        }
        if($(this).attr('href') == '/pages/trade-application') {
          gtag('event', 'trade_application_click');
        }
      });

      $('#email_signup_product .btn--submit').on('click', function() {
        // gtag('event','subscribe_click');
      });

      $('body').on('click', '.hero-carousel__title', function() {
        console.log('>> click body');
        if($('.hero-carousel .swiper-slide-active a').length) {
          var trgt = $('.hero-carousel .swiper-slide-active a').attr('href');
          if($('.hero-carousel .swiper-slide-active a').hasClass('link-new-tab')) {
            window.open(trgt,'_blank');  
          } else {
            window.open(trgt,'_self');  
          }  
        }

        // $('.hero-carousel .swiper-slide-active a').trigger('click');
        // setTimeout(function(){ $('.hero-carousel .swiper-slide-active a').trigger('click'); }, 100);
        // console.log('>> click body 2');
      });


      if($('body').hasClass('template-product')) {
        console.log('>> product class');
        localStorage.setItem('productScroll', $('.product-single').data('handle'));
      }
      if($('body').hasClass('template-collection')) {
        if(localStorage.getItem('productScroll') !== null) {
          console.log('product scroll ', localStorage.getItem('productScroll'));
          var handle = localStorage.getItem('productScroll');
          if($('[data-handle='+handle+']').length > 0) {
            var topPosition = $('[data-handle='+handle+']').offset().top;
            $('.collection-products').parent().parent().parent().parent().scrollTop(topPosition - 87)
          }
          localStorage.removeItem('productScroll');
        }
      }
      if(!($('body').hasClass('template-collection') || $('body').hasClass('template-product'))) {
        localStorage.removeItem('productScroll');
      }

      // apparatus.sortSearchResults();

      $('body').addClass(res);

      if($('.template-index .hero:not(.hero-hidden)').length) {
        if($('.template-index .hero:not(.hero-hidden)').length > 1) {
          var randomNumber = Math.random();
          var random = Math.floor(randomNumber * $('.template-index .hero:not(.hero-hidden)').length + 1);

          //var random = Math.floor(Math.random() * ($('.template-index .hero').length))
console.log('>>>>>>>>>>>>>>> ', random, '<< random', randomNumber);
          $('.template-index .hero:not(.hero-hidden)').eq(random-1).show();
        } else {
          $('.template-index .hero:not(.hero-hidden)').show();          
        }
      }

      $(window).on('scroll', function() {
        console.log('window scroll')
        $('video').each(function() {
          var video = $(this).get(0);

          if(video.paused) {

          } else {
            var vidHeight = $(this).outerHeight();
            var vidOffsetTop = $(this).offset().top;
            var vidScrollTop = $('html, body').scrollTop();
            var vidVisible = $(this).is(':visible');
            var vidHeaderHeight = $('.header').outerHeight();

            console.log(vidHeight, vidOffsetTop, vidScrollTop, vidVisible, vidHeaderHeight);

            if(vidHeight + vidOffsetTop - vidHeaderHeight - 100 > vidScrollTop) {
              $(this).prop('muted', false);    
            } else {
              $(this).prop('muted', true);                  
            }  
          }
        });
        
      });

      // detect horizontal and 

      if(typeof window.orientation == 'number') {
        angle = window.orientation;
      } else {
        if(typeof screen.orientation !== 'undefined') {
          angle = screen.orientation.angle;
        } else {
          angle = 0;
        }
      }

      console.log('>> screen orientation landscape? >> ', angle)


      if(window.innerWidth < 900 && (angle == 90 || angle == -90)) {
        // if(!$('body').hasClass('template-product')) {
          mobileLandscape = true;
        // }
      }

      window.addEventListener('orientationchange', function() {
        if(window.innerWidth < 900 && (angle == 90 || angle == -90)) {
          // if(!$('body').hasClass('template-product')) {
            mobileLandscape = true;
          // } else {
          //   mobileLandscape = false;
          // }
        } else {
          mobileLandscape = false;
        }
      });

      $(window).on('scroll', function() {
        if(mobileLandscape) {
          if(!headerFooterHidden) {
            headerFooterHidden = true;
            $('.header').css('top', '-60px');
            $('.collection-nav, .divider-footer, body:not(.template-product) .bottom-wrapper').css('bottom', '-60px');
          }
          
          window.clearTimeout(isScrolling);

          isScrolling = setTimeout(function() {
            console.log('scrolling stopped')
            headerFooterHidden = false;
            $('.header').css('top', '0px');
            $('.collection-nav, .divider-footer, body:not(.template-product) .bottom-wrapper').css('bottom', '0px');
          }, 250);

        }
      })


      var x = readCookie('gdpragreement');
      if(x) {
        $('#cookies-modal').remove();
      } else {
        if($('#email_signup_subscribe').length) {
          $('#cookies-modal').remove();
        } else {
          $('#cookies-modal').show();
          $('.cookies__close, .cookies .btn--submit').on('click', function() {
            createCookie('gdpragreement', '1', 360)
            $('#cookies-modal').remove();
            return false;
          });
        }
      }

      $('.search-form').on('submit', function() {
        var value = $(this).find('[name=q]').val();
        var valueElements = value.split(' ');
        if(valueElements.length > 1) {
          $(this).find('[name=q]').val('"'+value+'"');
        }
      });

      $('.video-wrapper-bg').on('click', function() {
        $(this).fadeOut();
        $(this).prev().find('.plyr__controls button').eq(0).trigger('click');
      });

      $('.page-faq-terms-amp-conditions').on('click', '.panel-content a', function() {
        console.log('inner-clicked');
        var text = $(this).text();
        if(text === 'I AGREE') {
          $(this).fadeOut();
        } else {
          var target = $(this).attr('href');
          var index = parseInt(target.substring(target.indexOf('-') + 1));
          console.log('inner: ', index);
          if(!isNaN(index)) {
            if(target.indexOf('left') > -1) {
              //$(this).toggleClass('active').next().toggleClass('panel-collapse');
              $('#shopify-section-page__faq-tc-left-section .panel').eq(index-1).find('.panel-toggle').toggleClass('active').next().toggleClass('panel-collapse');
            } else {
              //shopify-section-page__faq-tc-right-section
              $('#shopify-section-page__faq-tc-right-section .panel').eq(index-1).find('.panel-toggle').toggleClass('active').next().toggleClass('panel-collapse');
            }
          } else {
            return true;
          }
        }

        return false;
      });
      
      apparatus.animationPage();
      apparatus.resizeAnimation();
      apparatus.videoHome();
      apparatus.menu();
      apparatus.collection();
      apparatus.accordion();
      apparatus.customSelect();
      apparatus.subpageMenu();
      apparatus.drawer();
      apparatus.drawerMenu();
      apparatus.sliders();
      apparatus.tab();
      apparatus.cart();
      apparatus.bar();
      apparatus.modal();
      // apparatus.zoom();
      // apparatus.caption();

      $('#filter-first-column a').on('click', function() {
console.log('single-click?')
        var tagName = $(this).text().toLowerCase();
        if(tagName === 'table / floor') {
          tagName = 'table-floor';
        }
console.log(tagName)
console.log('active-filters 1', activeFilters)
        if($(this).hasClass('active-filter')) {
          $(this).removeClass('active-filter');
          activeFilters.splice(activeFilters.indexOf('type-'+tagName), 1);
        } else {
          $(this).addClass('active-filter')
          activeFilters.push('type-'+tagName);
        }
console.log('active-filters 2', activeFilters)

        $('.product-item').hide();
        console.log(tagName, '<<');

            var typesCount = 0;
        if(tagName === 'all') {
          $('.product-item').show();
          $('.active-filter').removeClass('active-filter');
          $('#filter-first-column li:first-child a').addClass('active-filter');
          activeFilters = [];
        } else {
          $('#filter-first-column li:first-child a').removeClass('active-filter');

          //activeFilters.splice(activeFilters.indexOf('type-all'), 1);
          // $('#filter-first-column li:first-child a').removeClass('active-filter');
          if(activeFilters.length > 0) {

            for(var i in activeFilters) {
              console.log('.product-item.'+activeFilters[i]);
              if(activeFilters[i].indexOf('type-') === 0) {
                $('.product-item.'+activeFilters[i]).show();
                typesCount++;
              }
            }

            if(typesCount > 0) {
              console.log('tpcou > 0')
              var seriesCount = 0;
              for(var i in activeFilters) {
                console.log('.product-item.'+activeFilters[i]);
                if(activeFilters[i].indexOf('series-') === 0) {
                  $('.product-item.'+activeFilters[i]+':visible').addClass('temp-vis');
                  seriesCount++;
                }
              }
              if(seriesCount > 0) {
                $('.product-item').hide();
                $('.product-item.temp-vis').show().removeClass('temp-vis');

              }
            } else {
              console.log('tpcou = 0')
              for(var i in activeFilters) {
                console.log('.product-item.'+activeFilters[i]);
                if(activeFilters[i].indexOf('series-') === 0) {
                  $('.product-item.'+activeFilters[i]).show();
                  // typesCount++;
                }
              }
            }

            // for(var i in activeFilters) {
            //   if(activeFilters[i].indexOf('series-') === 0) {
            //     $('.product-item.'+activeFilters[i]+':visible').show();
            //   }
            //   console.log('.product-item.'+activeFilters[i]);
            // }
          } else {
            $('.product-item').show();
          }
        }
        console.log(activeFilters);

        seriesFilters = [];
        $('#filter-third-column li').show();
        $('.product-item:visible').each(function() {
          var classes = $(this).attr('class');
          classes = classes.split(' ');
          // console.log(classes);
          for(var i in classes) {
            if(classes[i].indexOf('series-') > -1) {
              // console.log(classes[i]);
              if(seriesFilters.indexOf(classes[i]) === -1) {
                seriesFilters.push(classes[i]);
              }
            }
          }
        });

        console.log(seriesFilters);

        $('#filter-third-column a').each(function() {

          var name = $(this).text().toLowerCase();

          if(seriesFilters.indexOf('series-'+name) === -1) {
            $(this).parent().hide();
          }


        });
console.log('final 1', typesCount);
        if(typesCount === 0) {
          $('#filter-third-column li').show();
        } else {
          $('#filter-third-column li .active-filter').parent().show();
        }


        return false;
      });

      $('#filter-third-column a').on('click', function() {
        var tagName = $(this).text().toLowerCase();
        if(tagName.indexOf(' ') > -1) {
          tagName = tagName.replace(/\s+/g, '-');
        }

        if($(this).hasClass('active-filter')) {
          $(this).removeClass('active-filter');
          activeFilters.splice(activeFilters.indexOf('series-'+tagName), 1);
        } else {
          $(this).addClass('active-filter')
          activeFilters.push('series-'+tagName);
        }
        console.log(activeFilters);
        var typesCount = 0;

        $('.product-item').hide();
        if(activeFilters.length > 0) {
          // for(var i in activeFilters) {
          //   console.log('.product-item.'+activeFilters[i]);
          //   $('.product-item.'+activeFilters[i]).show();
          // }

            if(activeFilters.length > 1) {
              if(activeFilters.indexOf('type-all') > -1) {
                activeFilters.splice(activeFilters.indexOf('series-'+tagName), 1);
              }
            }


            for(var i in activeFilters) {
              console.log('.product-item.'+activeFilters[i]);
              if(activeFilters[i].indexOf('type-') === 0) {
                $('.product-item.'+activeFilters[i]).show();
                typesCount++;
              }
            }

            if(typesCount > 0) {
              var seriesCount = 0;
              for(var i in activeFilters) {
                console.log('.product-item.'+activeFilters[i]);
                if(activeFilters[i].indexOf('series-') === 0) {
                  $('.product-item.'+activeFilters[i]+':visible').addClass('temp-vis');
                  seriesCount++;
                }
              }

              if(seriesCount > 0) {
                $('.product-item').hide();
                $('.product-item.temp-vis').show().removeClass('temp-vis');

              }
            } else {
              for(var i in activeFilters) {
                console.log('.product-item.'+activeFilters[i]);
                if(activeFilters[i].indexOf('series-') === 0) {
                  $('.product-item.'+activeFilters[i]).show();
                  // typesCount++;
                }
              }
            }

        } else {
          $('.product-item').show();
        }
console.log('final 2', typesCount);
        if(typesCount === 0) {
          $('#filter-third-column li').show();
        }
        if($('#filter-third-column li .active-filter').length === 0) {
          $('#filter-third-column li').show();
        }
        return false;
      });

      apparatus.addToCart();

      // apparatus.stockistJson();
      var links = document.links;
      for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
        if (links[i].hostname !== window.location.hostname) {
          links[i].target = '_blank';
          links[i].rel = 'noreferrer noopener';
        }
      }

      // TODO
      // Duplicated event handling
      // $('.btn--add-to-cart').on('click', function() {
      //   var qty = $('#product-form-quantity').val();
      //   var pid = $('#product-form-id').val();
      //   var action = $('#add-item-form').attr('action');
      //   var datax = $('#add-item-form').serialize();
      //
      //   if(qty !== '' && pid !== '') {
      //     $.ajax({
      //       url: action,
      //       type: 'POST',
      //       dataType: 'json',
      //       data: datax,
      //       success: function(response) {
      //         console.log('success');
      //       },
      //       error: function(data){
      //         console.log('error');
      //       }
      //     });
      //   }
      // });

      if($('.gallery-event').length) {
        $("body").swipe({
          swipeLeft: function(event, direction, distance, duration, fingerCount) {
            console.log('> swipe left')
            if($('body').hasClass('mfp-zoom-out-cur')) {
              $('.mfp-arrow-right').magnificPopup('next');
            }
          },
          swipeRight: function() {
            console.log('> swipe right')
            if($('body').hasClass('mfp-zoom-out-cur')) {
              $('.mfp-arrow-left').magnificPopup('prev');
            }
          },
          threshold: 50
        });
        $("body").swipe('disable');
      }


    },

    /*******************
    * Functions
    ********************/

    /**
    * Sort Search Results
    */
    sortSearchResults: function() {
      if(window.location.href.indexOf('/search?') > -1) {
        var count = $('.product-item').length;

        for(var i = 0; i < count; i++) {
          var current = $('.product-item').get(i);
          var currentLink = $(current).find('.product-title a');
          if(currentLink.text().indexOf(':') > -1) {
            var productName = currentLink.text().split(' ');
            var productNameNext = currentLink.closest('.product-item').next().find('.product-title a').text();
            productNameNext = productNameNext.split(' ');
            if(parseInt(productName[2])) {
              if(parseInt(productName[2]) > parseInt(productNameNext[2]) && productName[0] === productNameNext[0]) {
                currentLink.closest('.product-item').insertAfter(currentLink.closest('.product-item').next());
              }
            }
          }
        }
      }
    },

    /*******************
    * Functions
    ********************/

    /**
    * Resize Animation
    */
    resizeAnimation: function() {
      var resizeTimer;
      window.addEventListener("resize", () => {
        document.body.classList.add("resize-animation-stopper");
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          document. body.classList.remove("resize-animation-stopper");
        }, 400);
      });
    },
    /**
    * Video Home
    */
    videoHome: function() {
      function video() {
        var videoSel = $('.full-video');
        videoSel.each(function() {
          var wrapperWidth = window.outerWidth,
          videoWidth = $(this).get(0).offsetWidth,
          videoHeight = $(this).get(0).offsetHeight;

          if (wrapperWidth < 1024) {
            var wrapperHeight = window.innerHeight + 100;
          } else {
            var wrapperHeight = window.innerHeight;
          }
          var scale = Math.max(wrapperWidth / videoWidth, wrapperHeight / videoHeight);
          scale = scale * 1.05;
          $(this).css('transform', 'translate(-50%, -50%) scale('+scale+') ');
        });
      }
      video();
      window.onresize = function (event) {
        video();
      };
    },
    /**
     * AOS
     */
    animationPage: function() {
      AOS.init(
      {
        duration: 800,
      }
      // {once: true}
      );
    },
    /**
     * Menu
    */
    menu: function() {
      var menuToggle = $('.menu-toggle');
      var bgColor = $("meta[name='theme-color']").attr('content');

      menuToggle.on('click', function() {
        $(this).parent('.header').toggleClass('menu-collapse');

        if(bgColor == '#6b6b6b') {
          if($('.header').hasClass('menu-collapse')) {
            setTimeout(function() {
              $("meta[name='theme-color']").attr('content', '#737372');
            }, 50);
            setTimeout(function() {
              $("meta[name='theme-color']").attr('content', '#7B7A7A');
            }, 100);
            setTimeout(function() {
              $("meta[name='theme-color']").attr('content', '#838281');
            }, 150);
            setTimeout(function() {
              $("meta[name='theme-color']").attr('content', '#8B8A89');
            }, 200);
            setTimeout(function() {
              $("meta[name='theme-color']").attr('content', '#929190');
            }, 250);
            setTimeout(function() {
              $("meta[name='theme-color']").attr('content', '#9A9998');
            }, 300);
            setTimeout(function() {
              $("meta[name='theme-color']").attr('content', '#A2A19F');
            }, 350);
            setTimeout(function() {
              $("meta[name='theme-color']").attr('content', '#AAA8A7');
            }, 400);
            setTimeout(function() {
              $("meta[name='theme-color']").attr('content', '#b2b0ae');
            }, 450);
          } else {
            setTimeout(function() {
              $("meta[name='theme-color']").attr('content', '#AAA8A7');
            }, 50);
            setTimeout(function() {
              $("meta[name='theme-color']").attr('content', '#A2A19F');
            }, 100);
            setTimeout(function() {
              $("meta[name='theme-color']").attr('content', '#9A9998');
            }, 150);
            setTimeout(function() {
              $("meta[name='theme-color']").attr('content', '#929190');
            }, 200);
            setTimeout(function() {
              $("meta[name='theme-color']").attr('content', '#8B8A89');
            }, 250);
            setTimeout(function() {
              $("meta[name='theme-color']").attr('content', '#838281');
            }, 300);
            setTimeout(function() {
              $("meta[name='theme-color']").attr('content', '#7B7A7A');
            }, 350);
            setTimeout(function() {
              $("meta[name='theme-color']").attr('content', '#737372');
            }, 400);
            setTimeout(function() {
              $("meta[name='theme-color']").attr('content', '#6b6b6b');
            }, 450);
          }
        }

        if(bgColor == '#c3c1bf') {
          if($('.header').hasClass('menu-collapse')) {
            setTimeout(function() {
              $("meta[name='theme-color']").attr('content', '#C0BEBC');
            }, 100);
            setTimeout(function() {
              $("meta[name='theme-color']").attr('content', '#BCBAB8');
            }, 200);
            setTimeout(function() {
              $("meta[name='theme-color']").attr('content', '#B9B7B5');
            }, 300);
            setTimeout(function() {
              $("meta[name='theme-color']").attr('content', '#B5B3B1');
            }, 400);
            setTimeout(function() {
              $("meta[name='theme-color']").attr('content', '#B2B0AE');
            }, 450);
          } else {
            setTimeout(function() {
              $("meta[name='theme-color']").attr('content', '#B5B3B1');
            }, 100);
            setTimeout(function() {
              $("meta[name='theme-color']").attr('content', '#B9B7B5');
            }, 200);
            setTimeout(function() {
              $("meta[name='theme-color']").attr('content', '#BCBAB8');
            }, 300);
            setTimeout(function() {
              $("meta[name='theme-color']").attr('content', '#C0BEBC');
            }, 400);
            setTimeout(function() {
              $("meta[name='theme-color']").attr('content', '#C3C1BF');
            }, 450);
          }
        }

        if($('.collection-nav').hasClass('filter-collapse')) {
          $('.filter-collapse').removeClass('filter-collapse');
          $('.filter-nav--hide').removeClass('filter-nav--hide');
          $('.body-overlay').removeClass('body-overlay');
        }
        if($('.site-submenu').hasClass('site-submenu--active')) {
          setTimeout(function(){
            $('.site-submenu').removeClass('site-submenu--active');
            $('.site-nav-mobile--hide').removeClass('site-nav-mobile--hide');
          },600);
        }
        return false;
      });

      var closeToggleWrapper = $('.main-wrapper');
      closeToggleWrapper.on('click', function() {
        if($('.header').hasClass('menu-collapse')) {
          $('.menu-collapse').removeClass('menu-collapse');
          if($('.site-submenu').hasClass('site-submenu--active')) {
            setTimeout(function(){
              $('.site-submenu').removeClass('site-submenu--active');
              $('.site-nav-mobile--hide').removeClass('site-nav-mobile--hide');
            },600);
          }
        }
      });

      var closeToggleFooter = $('.footer');
      closeToggleFooter.on('click', function() {
        if($('.header').hasClass('menu-collapse')) {
          $('.menu-collapse').removeClass('menu-collapse');
        }
      });

      /* Desktop menu */
      var menuToggleDesktop = $('.dropdown-menu-toggle');
      menuToggleDesktop.on('mouseover', function() {
        $('.header').addClass('menu-desktop-collapse');
        $(this).addClass('active');
        $(this).next('.dropdown-menu').addClass('dropdown-collapse');
        $('.filter-collapse').removeClass('filter-collapse');
        $('.filter-nav--hide').removeClass('filter-nav--hide');
        $('.body-overlay').removeClass('body-overlay');
      });

      var CloseMenuToggleDesktop = $('.header');
      CloseMenuToggleDesktop.on('mouseleave', function() {
        $('.header.menu-desktop-collapse').removeClass('menu-desktop-collapse');
        $('.dropdown-menu-toggle').removeClass('active');

        $('.subnav__item--active').next().hide();
        $('.subnav__item--active').removeClass('subnav__item--active');

        $('.nav .dropdown-menu.dropdown-collapse').removeClass('dropdown-collapse');
      });

      // $('body').on('click', function() {
      //   $('.menu-collapse').removeClass('menu-collapse');
      // });

      var dropdownToggle  = $('.dropdown-toggle');
      dropdownToggle.on('click', function() {
        console.log('whats that', $('.header .active').length, !$(this).hasClass('active'));
        if($('.header .active').length && !$(this).hasClass('active')) {
          if($(window).width() < 1024) {
            $('#'+$('.active').data('toggle')).slideToggle();
          }
          $('#'+$('.active').data('toggle')).removeClass('dropdown-collapse');
          $('.active').removeClass('active');console.log('remove 15');
          console.log('remove 2');
        }
        var target = '#' + $(this).data('toggle');
        if($(this).hasClass('active')) {
console.log('> click 1')
          $(this).removeClass('active');console.log('remove 31');
          $(target).removeClass('dropdown-collapse');
          if($(window).width() >= 1024) {
            $('.header').removeClass('menu-desktop-collapse');
          }

        } else {
        console.log('> click 2')
        if(target === '#contact1') {
         // ga('send','event','Contact Click');
         gtag('event', 'contact_click');
        }

          $(this).addClass('active');
          $(target).addClass('dropdown-collapse');
          if($(window).width() >= 1024) {
            $('.header').addClass('menu-desktop-collapse');
          }
          $('.drawer-menu-toggle').removeClass('active-drawer-menu-toggle');
          $('body').removeClass('drawer-menu-overlay').removeClass('drawer-overlay');
          $('.drawer-menu').removeClass('drawer-menu-collapse');
          $('.header').css('top', 0);
          $('.main-wrapper').removeAttr('style');
          if($(window).width() >= 1024) {
            console.log('> click 3');
            $('.collection-nav').removeClass('filter-collapse');
          }
          $('.drawer-toggle').removeClass('active-drawer-toggle');
          $('.bottom-wrapper').removeClass('drawer-collapse');
          $('.drawer').removeClass('active-drawer');
          if($(window).width() < 1024) {
            $(this).parent().siblings().find('a.dropdown-toggle.active').removeClass('active');console.log('remove 4');
            $(this).parent().siblings().find('.dropdown-collapse').removeClass('dropdown-collapse').slideToggle();

            // console.log($(this).next().height(), $(window).height(), 230)
            // if($(this).next().height() > $(window).height() - 230) {
            //   $(this).next().height($(window).height() - 230);
            // }
          }
        }
        if($(window).width() < 1024) {
          $(target).slideToggle();
        }
        return false;
      });
      var menuDesktopClose = $('.main-wrapper');
      menuDesktopClose.on('click', function() {
       if($(window).width() >= 1024) {
          $('.header').removeClass('menu-desktop-collapse');
          $('#'+$('.active').data('toggle')).removeClass('dropdown-collapse');
          $('.active').not('.panel-toggle').removeClass('active');console.log('remove 5');
          $('.dropdown-menu-toggle').removeClass('active');
          $('.nav .dropdown-menu.dropdown-collapse').removeClass('dropdown-collapse');
          $('.active-drawer-menu-toggle').removeClass('active-drawer-menu-toggle');
          $('.dropdown-currency--open').removeClass('dropdown-currency--open');
          $('.dropdown-currency__menu').slideUp();
        }
      });

      $(window).on('resize', function () {
        // $('.header .dropdown-menu').removeClass('dropdown-collapse');
        // $('.dropdown-toggle').removeClass('active');
        if($(window).width() < 1024) {
          $('.header').removeClass('menu-desktop-collapse');
          $('#'+$('.active').data('toggle')).removeClass('dropdown-collapse');
          $('.nav .dropdown-menu.dropdown-collapse').removeClass('dropdown-collapse');
        } else {
          $('.header').removeClass('menu-collapse');
          $('#'+$('.active').data('toggle')).removeClass('dropdown-collapse');
          $('.nav .dropdown-menu.dropdown-collapse').removeClass('dropdown-collapse');
        }
      });

     var subnavItem = $('.subnav__item');
      subnavItem.on('click', function() {
        $(this).next('.subnav__menu').slideToggle();
        $(this).toggleClass('subnav__item--active');
        return false;
      });

      /* Mobile menu */
      var linkMobile = $('.nav-link-mobile');
      linkMobile.on('click', function() {
        $(this).closest('.site-nav-mobile').addClass('site-nav-mobile--hide');
        $(this).closest('.filter-nav').addClass('filter-nav--hide')
        var target = '#' + $(this).data('nav-mobile');
        $('.site-submenu--active').removeClass('site-submenu--active').addClass('site-submenu--hide');
        $(target).addClass('site-submenu--active');
        return false;
      });

      var linkNavClose = $('.close-site-submenu');
      linkNavClose.on('click', function() {
        if($(this).parent().hasClass('site-submenu--active')) {
          $('.site-sub-submenu').removeClass('site-submenu--active');
          $('.site-submenu--hide').removeClass('site-submenu--hide').addClass('site-submenu--active');
          $('.filter-nav--hide').removeClass('filter-nav--hide');
        }

        if($(this).parent().hasClass('site-submenu--active')) {
          $('.site-submenu').removeClass('site-submenu--active');
          $('.site-nav-mobile--hide').removeClass('site-nav-mobile--hide');
          $('.filter-nav--hide').removeClass('filter-nav--hide');
        }
      });
    },
    /**
     * Collection
    */
    collection: function() {
      setTimeout(function(){
        $('.collection-products, .article-list, .row-grid').addClass('layout-ready');
      },800);

      var view = $('.grid-view');
      var currentView = $(view).find('[data-view]');
      currentView.on('click', function() {

        var viewType = $(this).data('view');
        $('.collection-products').removeClass('layout-ready');
        setTimeout(function(){
          console.log(viewType)
          if(viewType === 'small') {
            $('.collection-products').addClass('layout-ready');
            $(currentView).toggleClass('view-active');
            $('body').addClass('view-small-grid');
          } else if(viewType === 'large') {
            $('body').removeClass('view-small-grid');
            $('.collection-products').addClass('layout-ready');
            $(currentView).toggleClass('view-active');
          }
        },800);
      });

      var filterMenuToggle = $('.filter-menu-toggle');
      filterMenuToggle.on('click', function() {
        $(this).closest('.collection-nav').toggleClass('filter-collapse');
        $('body').toggleClass('body-overlay');
        $('.drawer-menu-toggle').removeClass('active-drawer-menu-toggle');
        $('body').removeClass('drawer-menu-overlay');
        $('.drawer-menu').removeClass('drawer-menu-collapse');
        $('.header').css('top', 0);
        $('.main-wrapper').removeAttr('style');
        $('.dropdown-toggle').removeClass('active');console.log('remove 6');
        $('.dropdown-menu').removeClass('dropdown-collapse');
        $('.header').removeClass('menu-desktop-collapse, menu-collapse');
        $('.dropdown-currency').removeClass('dropdown-currency--open');
        $('.dropdown-currency__menu').slideUp();
        if($('.site-sub-submenu').hasClass('site-submenu--active')) {
          setTimeout(function(){
            $('.site-sub-submenu').removeClass('site-submenu--active');
            $('.filter-nav').removeClass('filter-nav--hide');
          },600);
        }
        // if($('.site-sub-submenu').hasClass('site-submenu--active')) {
        //   setTimeout(function(){
        //     $('.site-sub-submenu').removeClass('site-submenu--active');
        //     $('.filter-nav').removeClass('filter-nav--hide');
        //   },700);
        // }
        return false;
      });

      $('.collection-products').on('click', function() {
        console.log('collection-product click')
        if($('.collection-nav').hasClass('filter-collapse')) {
          $('.collection-nav').removeClass('filter-collapse');
        }
      });

      var filterToggleClose = $('.collection, .footer, .header');
      filterToggleClose.on('click', function() {
        $('.filter-nav--hide').removeClass('filter-nav--hide');
        $('.filter-collapse').removeClass('filter-collapse');
        $('.body-overlay').removeClass('body-overlay');
        if($('.site-sub-submenu').hasClass('site-submenu--active')) {
          setTimeout(function(){
            $('.site-sub-submenu').removeClass('site-submenu--active');
            $('.filter-nav').removeClass('filter-nav--hide');
          },600);
        }
      });
    },
    /**
     * Custom Select
    */
    customSelect: function() {
      var customSelect = $('.custom-select');
      if(customSelect.length) {
        var $dropdownParent2 = $(customSelect).closest('.select-wrapper');
        customSelect.select2({
          //minimumResultsForSearch: -1,
          dropdownParent: $dropdownParent2,
          matcher: matchStart
        });
      }

      if($('.custom-select-cylinder-placeholder').length) {

        $('.custom-select-cylinder').not('.custom-select-cylinder-placeholder').each(function() {
          var $customSelect = $(this);
          $customSelect.select2({
           // minimumResultsForSearch: -1,
           dropdownParent: $customSelect.closest('.select-wrapper')
          });
        });

        $('.custom-select-cylinder-placeholder').each(function() {
          var $customSelect = $(this);
          $customSelect.select2({
            placeholder: $customSelect.attr('placeholder'),
            dropdownParent: $customSelect.closest('.select-wrapper')
          })
        })

        $('.custom-select-cylinder-placeholder').on('select2:select', function(e) {
          var value = e.params.data.id;
          var $currentSelect = $(this).closest('.form-row-step');

          if(value == 'downlight-d') {
            $currentSelect.find('.form-control-downlight, .form-control-downlight-extended, .form-control-pendant').hide().attr('disabled', 'true');
            $currentSelect.find('.form-control-downlight').show();
          } else if (value == 'downlight-extended-e') {
            $currentSelect.find('.form-control-downlight, .form-control-downlight-extended, .form-control-pendant').hide().attr('disabled', 'true');;
            $currentSelect.find('.form-control-downlight-extended').show().find('select').removeAttr('disabled');
          } else if (value == 'pendant-p') {
            $currentSelect.find('.form-control-downlight, .form-control-downlight-extended, .form-control-pendant').hide().attr('disabled', 'true');;
            $currentSelect.find('.form-control-pendant').show().find('select').removeAttr('disabled');
          }
        });
      }
      
      // if($('.custom-select').length) {
      //   $('.custom-select').not('.mums-select').select2({
      //     // placeholder: 'Select Amount',
      //     minimumResultsForSearch: -1,
      //     dropdownCssClass: "custom-select-dropdown"
      //   });
      // }

      var optionsToggle = $('.options-toggle');
      optionsToggle.on('click', function() {
        if(!$(this).closest('.options-wrapper').hasClass('options-collapse')) {
          $('.options-collapse').children('.options-menu').slideUp();
          $('.options-collapse').removeClass('options-collapse');
        }

        var dropdownWrapper = $(this).closest('.options-wrapper');
        var dropdownMenu = dropdownWrapper.children('.options-menu');
        dropdownWrapper.toggleClass('options-collapse');
        dropdownMenu.slideToggle();
        return false;
      });

      var selectToggleMenu = $('.options-menu-toggle');
      selectToggleMenu.on('click', function() {
        var variantid = $(this).data('variantid');
        if(typeof variantid !== 'undefined') {
          console.log('type');
          $('#product-form-id').val(variantid);
        } else {
          console.log('quantity');
          $('#product-form-quantity').val($(this).text());
        }
        var dropdownWrapperM = $(this).closest('.options-wrapper');
        var dropdownMenuM = dropdownWrapperM.children('.options-menu');
        var selectMenu = $(this).children('span').html();
        dropdownWrapperM.find('.options-toggle').html('<span> ' + selectMenu + '</span>');
        dropdownMenuM.slideUp();
        $('.options-collapse').removeClass('options-collapse');
      });
    },
    /**
     * Subpage Menu
    */
    subpageMenu: function() {
      var subpageToggle  = $('.subpage-toggle');
      subpageToggle.on('mouseover', function() {
        $('#related .subpage-image.active').removeClass('active');
        var targetSubpage = '#' + $(this).data('subpage');
        $(targetSubpage).addClass('active');
        $('#related .subpage-main-image').addClass('no-bg');
      });

      // subpageToggle.on('mouseout', function() {
      //   var targetSubpage = '#' + $(this).data('subpage');
      //   $(targetSubpage).removeClass('active');
      //   $('.subpage-main-image').removeClass('no-bg');
      // });
    },
    /**
     * Drawer
    */
    drawer: function() {
      var drawerToggle = $('.drawer-toggle');
      drawerToggle.on('click', function() {
      var imageSwiperWidth = $('.tab-column .gallery__image:visible img');
        console.log('count image width', imageSwiperWidth.length)
        var imgSwiperW = 0;

        if(imageSwiperWidth.length) {
          imgSwiperW = imageSwiperWidth.outerWidth() / 2;
        }
console.log('>> gallery x 5')
        var dta = $(this).data('drawer')
console.log('>> dta', dta)
        if(dta !== 'drawer-specifications') {

         if($('.gallery-section-nav:visible .gallery-nav').length) {
          if($(window).width() >= 1024) {
            $('.gallery-section-nav:visible .gallery-nav .gallery-button-prev').css('margin-left', -imgSwiperW - 50);
            $('.gallery-section-nav:visible .gallery-nav .gallery-button-next').css('margin-right', -imgSwiperW - 50);
          } else {
            $('.gallery-section-nav:visible .gallery-nav .gallery-button-prev').css('margin-left', -imgSwiperW - 20);
            $('.gallery-section-nav:visible .gallery-nav .gallery-button-next').css('margin-right', -imgSwiperW - 20);
          }
        }

      }

        if($(this).hasClass('active-drawer-toggle')) {

          $(this).removeClass('active-drawer-toggle');
          $('body').removeClass('drawer-overlay');
          $('.bottom-wrapper').removeClass('drawer-collapse');
          $('#'+$(this).data('drawer')).removeClass('active-drawer');

        } else {
          if($('body').hasClass('drawer-overlay')) {

            console.log('>> x')

            $('.drawer-collapse').removeClass('drawer-collapse');
            $('.active-drawer-toggle').removeClass('active-drawer-toggle');
            $('.active-drawer').removeClass('active-drawer');

            $(this).addClass('active-drawer-toggle');
            $('.bottom-wrapper').addClass('drawer-collapse');
            $('#'+$(this).data('drawer')).addClass('active-drawer');

          } else {

            console.log('>> y')

            if($(this).data('drawer') == 'drawer-specifications') {
              
              // ga('send','event','Specifications Click', $('.title-middle').text());
              // gtag('event','specifications_click', {
              //   'title': $('.title-middle').text()
              // });
            }
            
            $(this).addClass('active-drawer-toggle');
            $('body').addClass('drawer-overlay');
            $('.bottom-wrapper').addClass('drawer-collapse');
            $('#'+$(this).data('drawer')).addClass('active-drawer');

            $('.drawer-menu-toggle').removeClass('active-drawer-menu-toggle');
            $('body').removeClass('drawer-menu-overlay');
            $('.drawer-menu').removeClass('drawer-menu-collapse');
            $('.header').css('top', 0);
            $('.main-wrapper').removeAttr('style');
            $('.collection-nav').removeClass('filter-collapse');
            $('.dropdown-toggle').removeClass('active');console.log('remove 9');
            $('.dropdown-menu').removeClass('dropdown-collapse');
            if($(window).width() >= 1024) {
              $('.header').removeClass('menu-desktop-collapse');
            }

          }
        }
        return false;
      });

      var drawerClose = $('.drawer__close');
      drawerClose.on('click', function() {
        $(this).closest('.bottom-wrapper').removeClass('drawer-collapse');
        $('.active-drawer-toggle').removeClass('active-drawer-toggle');
        $('.active-drawer').removeClass('active-drawer');
        $('body').removeClass('drawer-overlay').removeClass('drawer-scroll');
        $('.dropdown-currency').removeClass('dropdown-currency--open');
        $('.dropdown-currency__menu').slideUp();
        return false;
      });

      /* Index Drawer & Bottom nav links after click */
      var drawerIndexToggle = $('.drawer-index-toggle');
        drawerIndexToggle.on('click', function() {
          var imageSwiperWidth = $('.swiper__video:visible video, .swiper__image:visible img');
          console.log('count image width', imageSwiperWidth.length)
          var imgSwiperW = 0;

          if(imageSwiperWidth.length) {
            imgSwiperW = imageSwiperWidth.outerWidth() / 2;
          }

          if($('.swiper-gallery:visible').length) {
            if($(window).width() >= 1024) {
              $('.swiper-gallery:visible .gallery-button-prev').css('margin-left', -imgSwiperW - 50);
              $('.swiper-gallery:visible .gallery-button-next').css('margin-right', -imgSwiperW - 50);
            } else {
              $('.swiper-gallery:visible .gallery-button-prev').css('margin-left', -imgSwiperW - 20);
              $('.swiper-gallery:visible .gallery-button-next').css('margin-right', -imgSwiperW - 20);
            }
          }


        $('video').each(function() {
          var video = $(this).get(0);
          // console.log(video, video.paused)
          if(video.paused) {

          } else {
            // $(this).prop('muted', true);
            video.pause();
          }
        });

        if($(this).hasClass('active-drawer-toggle')) {
          $(this).removeClass('active-drawer-toggle');
          $('body').removeClass('drawer-visible').removeClass('drawer-scroll');
          $('.active-index-drawer').removeClass('active-index-drawer active-index-drawer--filter');
          setTimeout(function() {
            var element = $('body').find('.drawer-index .simplebar-content-wrapper');
            element.scrollTop(0);
          }, 600);
        } else {
          if($('body').hasClass('drawer-visible')) {
            if($('#'+$(this).data('drawer')).hasClass('active-index-drawer--filter')) {
              $('#'+$(this).data('drawer')).removeClass('active-index-drawer--filter');
              $('#'+$(this).data('drawer')).addClass('active-index-drawer--temp')
            }
            $('body').removeClass('drawer-scroll');
            $('.active-index-drawer').not('.active-index-drawer--temp').addClass('active-index-drawer--filter');

            $('.active-index-drawer--temp').removeClass('active-index-drawer--temp');
            $('.active-drawer-toggle').removeClass('active-drawer-toggle');
            $(this).addClass('active-drawer-toggle');
            $('#'+$(this).data('drawer')).addClass('active-index-drawer');
            setTimeout(function() {
              var element = $('body').find('.drawer-index .simplebar-content-wrapper');
              element.scrollTop(0);
            }, 600);
            setTimeout(function() {
             $('.active-index-drawer--filter').removeClass('active-index-drawer active-index-drawer--filter');
               }, 700);
          } else {
            $(this).addClass('active-drawer-toggle');
            $('body').addClass('drawer-visible');
            $('#'+$(this).data('drawer')).addClass('active-index-drawer');
            if($(window).width() >= 1024) {
              $('.header').removeClass('menu-desktop-collapse');
            }
          }

        }
        return false;
      });

      var drawerIndexClose = $('.close-drawer-index');
      drawerIndexClose.on('click', function() {
        $(this).closest('.bottom-wrapper').removeClass('drawer-collapse');
        $('.active-drawer-toggle').removeClass('active-drawer-toggle');
        $('.active-index-drawer').removeClass('active-index-drawer');
        $('body').removeClass('drawer-visible').removeClass('drawer-scroll');
        setTimeout(function() {
          var element = $('body').find('.drawer-index .simplebar-content-wrapper');
          element.scrollTop(0);
        }, 600);
        $('video').each(function() {
          var video = $(this).get(0);
          // console.log(video, video.paused)
          if(video.paused) {

          } else {
            // $(this).prop('muted', true);
            video.pause();
          }
        });
        return false;
      });

      var element = $('body').find('.drawer-index .simplebar-content-wrapper');
      // $(element).on('scroll', function() {
      //   if($(this).scrollTop() > 0) {
      //     $('body').addClass('drawer-scroll');
      //   } else {
      //     $('body').removeClass('drawer-scroll');
      //   }
      // });

      $(element).on('scroll', function() {
        if($(this).scrollTop() > 0) {
          $('body').addClass('drawer-scroll');
        } else {
          $('body').removeClass('drawer-scroll');
        }
        if(mobileLandscape) {
          if(!headerFooterHidden) {
            headerFooterHidden = true;
            $('.header').css('top', '-60px');
            $('.bottom-wrapper').css('bottom', '-102px');
            $('.drawer-wrapper__content').css('padding-bottom', '0');
            $('.close-drawer-index').fadeOut();
          }

          window.clearTimeout(isScrollingDrawer);

          isScrollingDrawer = setTimeout(function() {
            console.log('scrolling stopped')
            headerFooterHidden = false;
            $('.header').css('top', '0px');
            $('.bottom-wrapper').css('bottom', '0');
            $('.drawer-wrapper__content').css('padding-bottom', '60px');
            $('.close-drawer-index').fadeIn();
          }, 250);

        }
      });

      /* Index links after click */
      var bottomLink = $('.bottom-nav__hero');
      bottomLink.on('click', function() {

        if($('.hero-hidden-active').length === 0) {
          $(this).addClass('bottom-nav__hero--active');
          $('#'+$(this).data('toggle')).addClass('hero-hidden-active');
          $(this).next('.bottom-nav__second-link').addClass('bottom-nav__second-link--active');
          if($('.hero-hidden-active video').length > 0) {
            $('.hero-hidden-active video')[0].play();
          }

        } else {
          if($(this).hasClass('bottom-nav__hero--active')) {
            if($('.hero-hidden-active video').length > 0) {
              $('.hero-hidden-active video')[0].pause();
              $('.hero-hidden-active video')[0].currentTime = 0;
            }

            $('.hero-hidden-active').removeClass('hero-hidden-active');
            $('.bottom-nav__second-link').removeClass('bottom-nav__second-link--active');
            $('.bottom-nav__hero').removeClass('bottom-nav__hero--active');
          } else {
            if($('.hero-hidden-active video').length > 0) {
              $('.hero-hidden-active video')[0].pause();
              $('.hero-hidden-active video')[0].currentTime = 0;
            }

            $('.hero-hidden-active').addClass('hero-hidden-active-temp');
            setTimeout(function() {
              $('.hero-hidden-active-temp').removeClass('hero-hidden-active hero-hidden-active-temp');
            }, 200);
            $('#'+$(this).data('toggle')).addClass('hero-hidden-active');

            $('.bottom-nav__second-link').removeClass('bottom-nav__second-link--active');
            $(this).next('.bottom-nav__second-link').addClass('bottom-nav__second-link--active');

            $('.bottom-nav__hero').removeClass('bottom-nav__hero--active');
            $(this).addClass('bottom-nav__hero--active');
            
            if($('.hero-hidden-active video').length > 0) {
              $('.hero-hidden-active video')[0].play();
            }
          }
        }

        if($(window).width() >= 1024) {
          $('.header').removeClass('menu-desktop-collapse');
        }
        return false;
      });
    },
    /**
     * Drawer
    */
    drawerMenu: function() {
      var drawerMenuToggle  = $('.drawer-menu-toggle');
      drawerMenuToggle.on('click', function() {
        $('.dropdown-currency').removeClass('dropdown-currency--open');
        $('.dropdown-currency__menu').slideUp();
        var drawerMenu = '#' + $(this).data('drawer');
        if($(this).hasClass('active-drawer-menu-toggle')) {
          $(this).removeClass('active-drawer-menu-toggle');
          $('body').removeClass('drawer-menu-overlay');
          $(drawerMenu).removeClass('drawer-menu-collapse');
          $('.header').css('top', 0);
          $('.main-wrapper').removeAttr('style');
        } else {

          if(window.location.href.indexOf('/search') > -1 && drawerMenu == '#search-bar') {
            console.log('here it goes');
            $('#search-page-form').trigger('focus');
            return false;
          }

          if($('body').hasClass('drawer-menu-overlay')) {
            $('.drawer-menu-collapse').removeClass('drawer-menu-collapse');
            $('.active-drawer-menu-toggle').removeClass('active-drawer-menu-toggle');
            $('.drawer-menu-collapser').removeClass('drawer-menu-collapse');

            $(this).addClass('active-drawer-menu-toggle');
            $(drawerMenu).addClass('drawer-menu-collapse');

            var cartWrapper = $('.drawer-menu-collapse .drawer-menu__wrapper');
            var cartWrapperH = 0;
            if(cartWrapper.length) {
              cartWrapperH = cartWrapper.outerHeight();
            }

            if($(drawerMenu).hasClass('drawer-menu-collapse')) {
              $('.header').css('top', cartWrapperH);
console.log('a1');
              $('.main-wrapper').css('top', cartWrapperH+80)
            }
          } else {
            $(this).addClass('active-drawer-menu-toggle');
            $('body').addClass('drawer-menu-overlay');
            $(drawerMenu).addClass('drawer-menu-collapse');

            var cartWrapper = $('.drawer-menu-collapse .drawer-menu__wrapper');
            var cartWrapperH = 0;
            if(cartWrapper.length) {
              cartWrapperH = cartWrapper.outerHeight();
            }

            if($(drawerMenu).hasClass('drawer-menu-collapse')) {
              $('.header').css('top', cartWrapperH);
console.log('a2');
              // $('.main-wrapper').css('top', cartWrapperH+80)
            }

            $('.dropdown-toggle').removeClass('active');console.log('remove 10');
            $('.dropdown-menu').removeClass('dropdown-collapse');
            if($(window).width() >= 1024) {
              $('.header').removeClass('menu-desktop-collapse');
            }
            $('.collection-nav').removeClass('filter-collapse');

            $('.drawer-toggle').removeClass('active-drawer-toggle');
            $('body').removeClass('drawer-overlay');
            $('.bottom-wrapper').removeClass('drawer-collapse');
            $('.drawer').removeClass('active-drawer');
          }
        }
        return false;
      });

      var searchItem = $('.related-search .related-search__item');
      var underlay = $('.related-search').find('.related-search-underlay');
      searchItem.on('mouseover', function() {
        var dropdownSearch = $('.related-search').find('.dropdown-search');
        dropdownSearch.css({visibility: 'visible', maxHeight: '200vh'}).animate({opacity: '1'}, 200);
        underlay.css('height', dropdownSearch.innerHeight() + 'px');
        return false;
      });

      searchItem.on('mouseleave', function() {
        var dropdownSearch = $('.related-search').find('.dropdown-search');
        dropdownSearch.animate({opacity: '0'}, 200, function() {
          dropdownSearch.css({visibility: 'hidden', maxHeight: '0px'});
        });
        underlay.css('height', '0');
        return false;
      });

      var drawerMenuClose  = $('.drawer-menu__close');
      var drawerMenuCloseBody = $('.main-wrapper');
      $('body').on('click', '.drawer-menu__close', function() {
       if($(this).closest('.drawer-menu').hasClass('drawer-menu-collapse')){
          $('.drawer-menu').removeClass('drawer-menu-collapse');
          $('body').removeClass('drawer-menu-overlay');
          $('.active-drawer-menu-toggle').removeClass('active-drawer-menu-toggle');
          // var header = $('.header');
          // if(header.length) {
          //   headerH = header.outerHeight();
          // }
          $('.header').css('top', 0);
          $('.main-wrapper').removeAttr('style');
          // $('.header, .main-wrapper').css('top', '0');
          // $('.collection-nav').css('top', headerH);
        }
       return false;
      });

      drawerMenuCloseBody.on('click', function() {
        if($('.drawer-menu').hasClass('drawer-menu-collapse')){
          $('.drawer-menu').removeClass('drawer-menu-collapse');
          $('body').removeClass('drawer-menu-overlay');
          // var header = $('.header');
          // if(header.length) {
          //   headerH = header.outerHeight();
          // }
          $('.header').css('top', 0);
          $('.main-wrapper').removeAttr('style');
          // $('.header, .main-wrapper').css('top', '0');
          // $('.collection-nav').css('top', headerH);
        }
      });
    },
    /**
     * Sliders
    */
    sliders: function() {

      $('.tab-column .gallery').each(function() {
        if($(this).find('.swiper-slide').length > 1) {
          $(this).closest('.gallery-section-nav').children('.gallery-nav').addClass('d-block');
        }
      });

      if($('.gallery .swiper-slide').length > 1) {
        if($('.gallery').length) {
          var idx = 0;
          $('.gallery').each(function() {
            $(this).addClass('gallery-'+idx);
            $(this).children().addClass('gallery-nav-'+idx);
            $(this).data('currid', idx);
            $(this).next().data('currid', idx);
            $(this).find('.swiper-pagination').addClass('swiper-pagination-'+idx);
            var recentlyCarousel = new Swiper('.gallery-'+idx, {
              slidesPerView: 1,
              threshold: 10,
              effect: 'fade',
              loop: true,
              observer: true,
              simulateTouch: false,
              updateOnWindowResize: true,
              resizeObserver: true,
              watchOverflow: true,
              watchSlidesVisibility: true,
              pagination: { 
                el: '.swiper-pagination-'+idx, 
                clickable: true,
                type: 'bullets',
              },
              // pagination: '.swiper-pagination',
              navigation: {
                nextEl: '.gallery-nav-'+idx+' .gallery-button-next, .left-arrow-area-overlay, .right-half-overlay',
                prevEl: '.gallery-nav-'+idx+' .gallery-button-prev, .right-arrow-area-overlay, .left-half-overlay',
              },
              on: {
                beforeInit: function() {
                  var tidx = $($(this)[0].el[0]).data('currid');

                  if($('.section-landing, .cylinder-gallery').length) {
                    // assume 0 for a while
                    var tidx = 0;

                    var imageSwiperWidth = $('.gallery-'+tidx+' .gallery__video:visible video, .gallery-'+tidx+' .gallery__image:visible img');
                    console.log('count image width', imageSwiperWidth.length)
                    var imgSwiperW = 0;

                    if(imageSwiperWidth.length) {
                      imgSwiperW = imageSwiperWidth.outerWidth() / 2;
                    }

                    if($('.cylinder-gallery').length) {
                      var width = $('.gallery-'+tidx+'  .gallery__image:visible img:visible');
                      console.log('cylgal:: ', tidx, width.length, width.outerWidth())
                      imgSwiperW = width.outerWidth() / 2;
                      if($(window).width() < 1024) {
                        imgSwiperW = imgSwiperW - 21;
                      }
                    }
                    console.log('count image width >> x6x6', imgSwiperW)

                    if($('.gallery-section-nav:visible .gallery-nav-'+tidx).length) {
                      if($(window).width() >= 1024) {
                        // $('.gallery-nav').width(imageSwiperWidth.outerWidth());
                        $('.gallery-section-nav:visible .gallery-nav-'+tidx+' .gallery-button-prev').css('margin-left', -imgSwiperW - 50);
                        $('.gallery-section-nav:visible .gallery-nav-'+tidx+' .gallery-button-next').css('margin-right', -imgSwiperW - 50);
                      } else {
                        $('.gallery-section-nav:visible .gallery-nav-'+tidx+' .gallery-button-prev').css('margin-left', -imgSwiperW - 20);
                        $('.gallery-section-nav:visible .gallery-nav-'+tidx+' .gallery-button-next').css('margin-right', -imgSwiperW - 20);
                      }
                    }
                  }

                  if($(window).width() >= 1024) {
                     $('.gallery-'+tidx).find('.zoom-img').zoom({
                      magnify: 1
                    });
                  }
                },
                slideChangeTransitionStart: function(swiper) {
                    var $wrapperEl = swiper.$wrapperEl;
                    var params = swiper.params;
                    if($wrapperEl) {
                      $wrapperEl.children(('.' + (params.slideClass) + '.' + (params.slideDuplicateClass)))
                      .each(function() {
                          var idx = this.getAttribute('data-swiper-slide-index');
                          this.innerHTML = $wrapperEl.children('.' + params.slideClass + '[data-swiper-slide-index="' + idx + '"]:not(.' + params.slideDuplicateClass + ')').html();
                      });
                    }
                },
                slideChangeTransitionEnd: function(swiper) {
                  swiper.slideToLoop(swiper.realIndex, 0, false);
                },
                resize: function() {
                  var tidx = $($(this)[0].el[0]).data('currid');

                  if($('.section-landing, .cylinder-gallery').length) {
                    // assume 0 for a while
                    var tidx = 0;

                    var imageSwiperWidth = $('.gallery-'+tidx+' .gallery__video:visible video, .gallery-'+tidx+' .gallery__image:visible img');
                    console.log('count image width', imageSwiperWidth.length)
                    var imgSwiperW = 0;

                    if(imageSwiperWidth.length) {
                      imgSwiperW = imageSwiperWidth.outerWidth() / 2;
                    }

                    if($('.cylinder-gallery').length) {
                      var width = $('.gallery-'+tidx+'  .gallery__image:visible img:visible');
                      console.log('cylgal:: ', tidx, width.length, width.outerWidth())
                      imgSwiperW = width.outerWidth() / 2;
                      if($(window).width() < 1024) {
                        imgSwiperW = imgSwiperW - 21;
                      }
                    }

                    if($('.gallery-section-nav:visible .gallery-nav-'+tidx).length) {
                      if($(window).width() >= 1024) {
                        // $('.gallery-nav').width(imageSwiperWidth.outerWidth());
                        $('.gallery-section-nav:visible .gallery-nav-'+tidx+' .gallery-button-prev').css('margin-left', -imgSwiperW - 50);
                        $('.gallery-section-nav:visible .gallery-nav-'+tidx+' .gallery-button-next').css('margin-right', -imgSwiperW - 50);
                      } else {
                        $('.gallery-section-nav:visible .gallery-nav-'+tidx+' .gallery-button-prev').css('margin-left', -imgSwiperW - 20);
                        $('.gallery-section-nav:visible .gallery-nav-'+tidx+' .gallery-button-next').css('margin-right', -imgSwiperW - 20);
                      }
                    }
                  }
                }
              }
            });
            recentlyCarousel.on('slideChange', function () {
              $('video').each(function() {
                var video = $(this).get(0);
                if(video.paused) {

                } else {  
                  video.pause();
                }
              });
            });
            idx++;
          });
        }
      }

      if($('.gallery-drawer .swiper-slide').length > 1) {
        if($('.gallery-drawer').length) {
          var idx = 0;
          $('.gallery-drawer').each(function() {
            $(this).addClass('gallery-drawer-'+idx);
            $(this).next().addClass('gallery-drawer-nav-'+idx);

            var recentlyCarousel = new Swiper('.gallery-drawer-'+idx, {
              slidesPerView: 1,
              threshold: 10,
              effect: 'fade',
              loop: true,
              observer: true,
              updateOnWindowResize: true,
              resizeObserver: true,
              watchOverflow: true,
              watchSlidesVisibility: true,
              navigation: {
                nextEl: '.gallery-drawer-nav-'+idx+' .gallery-button-next',
                prevEl: '.gallery-drawer-nav-'+idx+' .gallery-button-prev',
              },
              on: {
                slideChangeTransitionStart: function(swiper) {
                    var $wrapperEl = swiper.$wrapperEl;
                    var params = swiper.params;
                    if($wrapperEl) {
                      $wrapperEl.children(('.' + (params.slideClass) + '.' + (params.slideDuplicateClass)))
                      .each(function() {
                          var idx = this.getAttribute('data-swiper-slide-index');
                          this.innerHTML = $wrapperEl.children('.' + params.slideClass + '[data-swiper-slide-index="' + idx + '"]:not(.' + params.slideDuplicateClass + ')').html();
                      });
                    }
                },
                slideChangeTransitionEnd: function(swiper) {
                  swiper.slideToLoop(swiper.realIndex, 0, false);
                },
              }
            });
            recentlyCarousel.on('slideChange', function () {
              $('video').each(function() {
                var video = $(this).get(0);
                if(video.paused) {

                } else {  
                  video.pause();
                }
              });
            });
            idx++;
          });
        }
      }

      if($('.about-gallery .swiper-slide').length > 1) {
        var aboutGallery = new Swiper('.about-gallery', {
          pagination: { el: '.swiper-pagination' },
          navigation: {
            nextEl: '.gallery-button-next',
            prevEl: '.gallery-button-prev',
          },
        });
      }
    },
    /**
     * Tabs
    */
    tab: function() {


      var tabToggle = $('.tab-toggle');

      if(tabToggle.length) {
        var txt = tabToggle.eq(0).text();
        $('.pdp-form-product-variant').val('Apparatus Inquiry : '+txt);
        $('#inquiry-modal .form-control-textarea').text(`Hello,
I am interested in the ${txt}. Please send further details.`);
      }

      tabToggle.on('click', function() {
        if($(window).width() >= 1024) {

          var targetTab = '#' + $(this).data('tab');
          var targetTabImg = '[data-gallery='+$(this).data('tab').substring(4)+']';
          $('.tab-nav .active-tab').removeClass('active-tab');
          $('.tab-collapse').hide().removeClass('tab-collapse');
          $('.active-new-tab').hide().removeClass('active-new-tab');
         

          $(this).addClass('active-tab');
          $(targetTab).addClass('tab-collapse');
          $(targetTabImg).addClass('active-new-tab');
          $(targetTabImg).show();
          $(targetTab).show();
   
          var tidx = $(this).parent().index() + 1;

          $(targetTab).find('.zoom-img').zoom({
            magnify: 1
          });

        } else {
          $('.tab-nav .active-tab').removeClass('active-tab');
          $('.tab-collapse').hide().removeClass('tab-collapse');
          $('.active-new-tab').hide().removeClass('active-new-tab');
        }

        var txt = $(this).text();
        $('.pdp-form-product-variant').val('Apparatus Inquiry : '+txt);
        $('#inquiry-modal .form-control-textarea').text(`Hello,
I am interested in the ${txt}. Please send further details.`);
      });

      $('.template-product .product-desc .tab-toggle').on('click', function() {
        window.location.hash = '#'+$(this).data('tab')+'-variant';
      });

      if($('.template-product .product-desc .tab-toggle').length) {
        var hash = window.location.hash;
        hash = hash.replace('-variant', '');
        if(hash.indexOf('#tab') > -1) {
          $('.template-product .product-desc .tab-toggle[data-tab="'+hash.substring(1)+'"]').trigger('click');
        }
      }

      var tabWidgetToggle = $('.tabs-widget .bottom-nav li');
      tabWidgetToggle.on('click', function() {
        var targetWidgetTab = '#' + $(this).data('index');
          $('.bottom-nav .active-widget-tab').removeClass('active-widget-tab');
          $('.tab-collapse').hide().removeClass('tab-collapse');
          $(this).addClass('active-widget-tab');
          $(targetWidgetTab).addClass('tab-collapse');
          $(targetWidgetTab).show();
          var imageSwiperWidth = $('.tabs-widget .gallery__video:visible video, .tabs-widget .gallery__image:visible img');
            console.log('count image width', imageSwiperWidth.length)
            var imgSwiperW = 0;

            if(imageSwiperWidth.length) {
              imgSwiperW = imageSwiperWidth.outerWidth() / 2;
            }

            if($('.tabs-widget .gallery-section:visible').length) {
              if($(window).width() >= 1024) {
                $('.tabs-widget .gallery-section:visible .gallery-button-prev').css('margin-left', -imgSwiperW - 50);
                $('.tabs-widget .gallery-section:visible .gallery-button-next').css('margin-right', -imgSwiperW - 50);
              } else {
                $('.tabs-widget .gallery-section:visible .gallery-button-prev').css('margin-left', -imgSwiperW - 20);
                $('.tabs-widget .gallery-section:visible .gallery-button-next').css('margin-right', -imgSwiperW - 20);
              }
            }
          return false;
      });

       var tabToggleCylinder = $('.tab-label-toggle');
       tabToggleCylinder.on('click', function() {
          var targetTabGallery = '#' + $(this).data('tab');

          $('.tab-labels .tab-label-toggle--active').removeClass('tab-label-toggle--active');
          $('.tab-content').hide().removeClass('tab-content--visible');
          $(this).addClass('tab-label-toggle--active');
          $(targetTabGallery).addClass('tab-content--visible');
          $(targetTabGallery).show();
       });
    },
    /**
     * Cart
    */
    cart: function() {
      $('body').on('click', '.drawer-menu__wrapper .remove', function() {
        var url = $(this).attr('href');
        var qty = parseInt($(this).prev().find('input').val());
        $( ".drawer-cart .drawer-menu__wrapper" ).load( url + " .drawer-cart .drawer-menu__wrapper" );
        var cartCount = parseInt($('.minicart-count').text());
        var finalCount = cartCount - qty;
        if(finalCount !== 0) {
          $('.minicart-count').text(finalCount);
        } else {
          $('.minicart-count').text('').addClass('hidden-count');
        }
        setTimeout(function() {
            var cartWrapper = $('.drawer-menu-collapse .drawer-menu__wrapper');
            var cartWrapperH = 0;
            if(cartWrapper.length) {
              cartWrapperH = cartWrapper.height();
            }

            $('.header').css('top', cartWrapperH);
console.log('a3');
            $('.main-wrapper').css('top', cartWrapperH+80)
          }, 1000);

        return false;
      });

      $('body').on('click', '.quantity-decrease', function () {
        var target = $(this).siblings('.quantity-input');
        var currentQuantity = $(target).val();
        if (currentQuantity > 1) {
          $(target).val(--currentQuantity);
          if($('body').hasClass('template-cart')) {
            console.log('cart page');
            $(this).closest('form.cart').submit();
          } else {
            console.log('mini cart');
            $.ajax({
              url: $('.drawer-menu__wrapper .cart').attr('action'),
              type: 'POST',
              dataType: 'json',
              data: $('.drawer-menu__wrapper .cart').serialize(),
              success: function(response) {
                console.log(response);

                var count = $('.minicart-count').text();
                if(count !== '') {
                  count = parseInt(count) - 1;
                } else {
                  count = 1;
                }
                
                $('.minicart-count').text(count).removeClass('hidden-count');

                $( ".drawer-cart .drawer-menu__wrapper" ).load( "/ .drawer-cart .drawer-menu__wrapper" );
              },
              error: function(data){
                revertButtonLabel();
                alert('No more units available.');
              }
            })
          }
          //if($('body').hasClass('template-cart')) {
            //$(this).closest('form.cart').submit();
          //}
        }
      });

      $('body').on('click', '.quantity-increase', function () {
        console.log('increase')
        var target = $(this).siblings('.quantity-input');
        var currentQuantity = parseInt($(target).val()) + 1;
        console.log(currentQuantity);
        $(target).val(currentQuantity);
        // if($('body').hasClass('template-cart')) {
        //  $(this).closest('form.cart').submit();
        // }
        if (currentQuantity > 0) {
          $(target).val(currentQuantity);
          if($('body').hasClass('template-cart')) {
            console.log('cart page');
            $(this).closest('form.cart').submit();
          } else {
            console.log('mini cart');
            $.ajax({
              url: $('.drawer-menu__wrapper .cart').attr('action'),
              type: 'POST',
              dataType: 'json',
              data: $('.drawer-menu__wrapper .cart').serialize(),
              success: function(response) {
                console.log(response);

                var count = $('.minicart-count').text();
                if(count !== '') {
                  count = parseInt(count) + 1;
                } else {
                  count = 1;
                }
                
                $('.minicart-count').text(count).removeClass('hidden-count');

                $( ".drawer-cart .drawer-menu__wrapper" ).load( "/ .drawer-cart .drawer-menu__wrapper" );
              },
              error: function(data){
                revertButtonLabel();
                alert('No more units available.');
              }
            })
          }
          //if($('body').hasClass('template-cart')) {
            //$(this).closest('form.cart').submit();
          //}
        }
      });

      $('body').on('blur', '.template-cart .quantity-input', function() {
        $('form.cart').submit();
      });
    },
    /**
     * Caption
    */
    caption: function() {
      var carouselSlideCaption = $('.carousel__image');
      var captionSlide = $('.carousel__image figcaption');
      var captionSlideH = 0;
      if(captionSlide.length) {
        captionSlideH = captionSlide.outerHeight();
      }
      if(carouselSlideCaption.hasClass('carousel__image--caption')) {
        $(this).css('padding-top', captionSlideH);
      }
    },
    /**
     * Add to cart
    */
    addToCart: function() {
      $('.btn--add-to-cart').on('click', function() {
        var productid = $('#product-form-id').val();
        var quantity = $('#product-form-quantity').val();
        var $addToCartButton = $('.btn--add-to-cart');
        var buttonLabelBefore = $addToCartButton.text();
        var buttonLabelAfter = 'Added';
        $('.error-message').hide();

        var revertButtonLabel = function(delayed) {
          if(delayed) {
            setTimeout(
                () => $addToCartButton.hide().text(buttonLabelBefore).fadeIn(1000),
                2000);
          } else {
            $addToCartButton.text(buttonLabelBefore);
          }
        }

        console.log(productid, quantity);
        if(productid !== '' && quantity !== '') {

          // Move this line to "success" callback
          // to display changed label with certainty, that item was added to cart
          $addToCartButton.text(buttonLabelAfter);

          $.ajax({
            url: $('#add-item-form').attr('action'),
            type: 'POST',
            dataType: 'json',
            data: $('#add-item-form').serialize(),
            success: function(response) {
              console.log(response);

            revertButtonLabel(true);

              var count = $('.minicart-count').text();
              if(count !== '') {
                count = parseInt(count) + parseInt(quantity);
              } else {
                count = parseInt(quantity);
              }
              
              $('.minicart-count').text(count).removeClass('hidden-count');

              $( ".drawer-cart .drawer-menu__wrapper" ).load( "/ .drawer-cart .drawer-menu__wrapper" );
            },
            error: function(data){
              revertButtonLabel();
              alert('No more units available.');
            }
          })
        } else {
          $('.error-message').fadeIn();
        }
      //   var anySelectedVariant = $('.swatch-size__control:checked').length === 0 ? false : true;
      //   if($('#add-submit').is(':visible')) {
      //     var anySelectedVariant = true;
      //   }

      //   $('.atc-error').removeClass('atc-error');

      //   if(!anySelectedVariant) {
      //     $('.swatch-size__item').not('.swatch-size-unavailable').addClass('atc-error');
      //     $('form .product-variants-title').addClass('atc-error');
      //   } else {
      //     $.ajax({
      //       url: $(this).attr('action'),
      //       type: 'POST',
      //       dataType: 'json',
      //       data: $(this).serialize(),
      //       success: function(response) {
      //         var count = $('.cart-count').text();
      //         count = count.substring(1, count.length - 1);
      //         count = parseInt(count) + 1;
      //         $('.cart-count').text('('+count+')');

      //         $('#add-submit').text('Product added to cart');
      //         $('#add-submit').removeClass('btn--dark').addClass('btn--white').attr('disabled', true);

      //         $('.cart-ic').addClass('active-cart');

      //         setTimeout(function() {
      //           $('#add-submit').text('Add To Bag');
      //           $('#add-submit').addClass('btn--dark').removeClass('btn--white').removeAttr('disabled');
      //         }, 2500);
      //       },
      //       error: function(data){
      //         alert('No more units available.');
      //       }
      //     })
      //   }

        return false;
      });
    },

    // stockistJson: function() {
    //   if($('body').hasClass('page-stockists')) {
    //     console.log('>> stockist', stockistUrl);
    //     $.getJSON(stockistUrl).done(function(data) {
    //       console.log(data);
    //       for(var i in data) {
    //         console.log('>> ', i, data[i]);
    //         var html = '<div class="panel">';
    //         html += '<h4 class="panel-toggle">'+i+'</h4>';
    //         html += '<div class="panel-content"><div class="panel-wrapper" data-simplebar>';
    //         for(var j in data[i].countries) {
    //           console.log('country: ', j);
    //           for(var k in data[i].countries[j]) {
    //             console.log(k);
    //             html += '<div class="store">';
    //             html += '<span class="store__name">'+data[i].countries[j][k].name+'</span>';
    //             html += '<span>'+data[i].countries[j][k].address2+'</span>';
    //             html += '<span class="store__site"><a href="//'+data[i].countries[j][k].url+'" target="blank">'+data[i].countries[j][k].url+'</a></span>';
    //             if(data[i].countries[j][k].note !== '') {
    //               html += '<span>'+data[i].countries[j][k].note+'</span>';
    //             }
    //             html += '</div>';
    //           }
    //         }
    //         html += '</div></div>';
    //         html += '</div>';
    //         $('.stockists').append(html);
    //       }
    //       apparatus.accordion();
    //     });
    //   }
    // },
    /**
     * Simple Bar Desktop Only
    */
    bar: function() {
      var scrollBar = $('.simplebar-desktop');

      if($(window).width() > 1023) {
        $(scrollBar).each((index, element) => new SimpleBar(element));
      }

      $(window).on('resize', function () {
        var scrollBarSet = $('.simplebar-desktop');
        if($(window).width() > 1023) {
          $(scrollBarSet).each((index, element) => new SimpleBar(element));
        } 
      });



      $('.simplebar-content-wrapper').on('scroll', function() {
        console.log('simplebar scroll')
        $('video').each(function() {
          var video = $(this).get(0);
          // console.log(video, video.paused)
          if(video.paused) {

          } else {
            // $(this).prop('muted', true);

            var vidHeight = $(this).outerHeight();
            var vidOffsetTop = $(this).offset().top;
            var vidScrollTop = $('html, body').scrollTop();
            var vidVisible = $(this).is(':visible');
            var vidHeaderHeight = $('.header').outerHeight();

            console.log(vidHeight, vidOffsetTop, vidScrollTop, vidVisible, vidHeaderHeight);

            if(vidHeight + vidOffsetTop - vidHeaderHeight - 100 > vidScrollTop) {
              $(this).prop('muted', false);    
            } else {
              $(this).prop('muted', true);                  
            }  
          }
        });
        
      });
    },
    /**
     * Accordion / Accordion Mobile
    */
    accordion: function() {
      var panelToggle  = $('.panel-toggle:not(.panel-toggle--disabled):not(.no-caret)');
      panelToggle.on('click', function() {
        console.log('panel toggle execution');
        if($(window).width() > 1024) {
          if($('.panel > .active').length && !$(this).hasClass('active')) {
            $('.active').next().removeClass('panel-collapse');
            $('.active').removeClass('active');console.log('remove 12');
          }
        }
        $(this).toggleClass('active').next().toggleClass('panel-collapse');
        $('.dropdown-currency').removeClass('dropdown-currency--open');
        $('.dropdown-currency__menu').slideUp();
        return false;
      });

      var panelToggleMobile  = $('.panel-mobile__toggle');
      panelToggleMobile.on('click', function() {
        $('.menu-collapse').removeClass('menu-collapse');
        $('.dropdown-currency').removeClass('dropdown-currency--open');
        $('.filter-nav--hide').removeClass('filter-nav--hide');
        $('.filter-collapse').removeClass('filter-collapse');
        $('.body-overlay').removeClass('body-overlay');
        $('.dropdown-currency__menu').slideUp();
        if($(window).width() < 1025) {
          // if($('.panel-mobile .single-drawer > .panel-mobile__toggle--active, .tab-wrapper .panel-mobile__toggle--active').length && !$(this).hasClass('panel-mobile__toggle--active')) {
          //   $('.panel-mobile__toggle--active:not(.footer__tab-toggle)').next().removeClass('panel-collapse-mobile');
          //   $('.panel-mobile__toggle--active:not(.footer__tab-toggle').removeClass('panel-mobile__toggle--active');
          // }
          // $('.carousel').slick('refresh');
          // $('.carousel-materials').slick('refresh');
          $(this).toggleClass('panel-mobile__toggle--active').next().toggleClass('panel-collapse-mobile');
        }
        return false;
      });

      $('.footer__tab-toggle').on('click', function() {
        if($(window).width() < 1025) {
          if($(this).hasClass('active')) {

          } else {
            $("html, body").animate({ scrollTop: $(document).height() }, 1000);
          }
        }
      })

      // $(window).on('resize', function () {
      //   $('.panel .active').removeClass('active');
      //   $('.panel-collapse').removeClass('panel-collapse');
      //   $('.panel-mobile__toggle--active').removeClass('panel-mobile__toggle--active');
      //   $('.panel-collapse-mobile').removeClass('panel-collapse-mobile');
      // });
    },
    /**
     * Trade Application Modal / Subscribe Modal
    */
    modal: function() {
      // Newsletter Modal
      var newsletterToggle = $('.newsletter-toggle');
      var newsletterClose = $('.newsletter__close');
      newsletterToggle.on('click', function() {
        $(this).addClass('active');
        $('.newsletter').addClass('newsletter--open');
        
		// ga('send','event','Subscribe Click');
    gtag('event','subscribe_click');
      });
       newsletterClose.on('click', function() {
        $('.newsletter').removeClass('newsletter--open');
        $('.newsletter-toggle.active').removeClass('active');
      });
    },

    zoom: function() {
      $('.zoom-img').zoom({
        magnify: 1
      });
    }
  };

  $(function () {
    apparatus.init();
  });

})(jQuery);

$(document).ready(function() {
  $('form.mailchimp-form').on('submit', function(e) {
    // e.preventDefault();

    // var $this = $(this);
    // $('.error-msg, .success-msg').hide();

    // $.ajax({
    //   type: "GET",
    //   url: $this.attr('action'),
    //   data: $this.serialize(),
    //   dataType: 'json',
    //   contentType: "application/json; charset=utf-8",
    //   error: function(err) {
    //     $('.error-msg div').text('Something went wrong. Please try again.').fadeIn();
    //   },
    //   success: function(data) {
    //     if (data.result != "success") {
          // $('.error-msg div').html(data.msg);
          // $('.error-msg div a').remove();
          // $('.error-msg').fadeIn();
    //     } else {
    //       $('.success-msg div').text('Thanks for signing up!');
    //       $('.success-msg').show();
    //     }
    //   }
    // });

    // return false;
  });
});

function createCookie(name,value,days) {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime()+(days*24*60*60*1000));
    var expires = "; expires="+date.toGMTString();
  }
  else var expires = "";
  document.cookie = name+"="+value+expires+"; path=/";
}

function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}

function eraseCookie(name) {
  createCookie(name,"",-1);
}

if(window.location.pathname == '/collections' || window.location.pathname == '/products' || window.location.pathname == '/blog' || window.location.pathname == '/pagesx') {
 	window.location.href = '/' 
}

if(window.location.pathname == '/collections/' || window.location.pathname == '/products/' || window.location.pathname == '/blog/' || window.location.pathname == '/pagesx/') {
 	window.location.href = '/' 
}

// subscribe page

$(document).ready(function() {
  $('#email_signup_subscribe').on('submit', function(e) {
      e.preventDefault();
      const tableName = 'Users';
      const baseId = 'appeQ78SqPykLnFH8';
      const apiKey = 'pat5QDv1OoL1RBgjv.b8d3d43bac02bb3c66a31d6799630179bcaf8fba738839c04df238ce5740d264';

      const formData = $('#email_signup_subscribe').serializeArray();
      const dataToSend = {};

      $.each(formData,
          function(index, item) {
              dataToSend[item.name] = item.value;
          });

      $.ajax({
          type: "POST",
          url: `https://api.airtable.com/v0/${baseId}/${tableName}`,
          headers: {
              Authorization: `Bearer ${apiKey}`,
          },
          contentType: "application/json",
          dataType: 'json',
          data: JSON.stringify({
              records: [{
                  fields: dataToSend,
              }]
          }),
          success: function() {
              $('#subscribe-modal').show();
              $('#email_signup_subscribe')[0].reset();
          }
      });

      return false;
  });

  $('#subscribe-modal .popup-general__close').on('click', function() {
    $('#subscribe-modal').hide();
    return false;
  });
});


// uk vs us
$(document).ready(function() {
  if($('.expedited-settings').length) {
    $('.expedited-settings').each(function() {
      if($(this).hasClass('expedited-one-tearsheet')) {
        $(this).find('.tear-us, .tear-uk').show();
      }
      if($(this).hasClass('expedited-two-tearsheets')) {
        if(window.location.href.indexOf('.com') > -1) {
          $(this).find('.tear-us').show();
        } else {
          $(this).find('.tear-uk').show();
        }
      }
    });
  } else {
    if($('.tear-us').length) {
      if(window.location.href.indexOf('.com') > -1) {
        $('.tear-us').show();
      } else {
        $('.tear-uk').show();
      }
    }  
  }


});

$(document).ready(function() {
  if($('#select-country-generated').length) {
    var countryNames = Object.keys(Countries)
    var countryProps = Object.values(Countries)
    for(var i in countryNames) {
      // console.log(countryNames[i]);
      $('#select-country-generated').append('<option value="'+countryNames[i]+'">'+countryNames[i]+'</option>');

      if(countryProps[i].provinces) {
        // console.log('provinces for: ', countryNames[i]);
        var shouldBeRequired = $('.form-group-provinces input').prop('required');
        var output = '<div class="select-wrapper" data-country="'+countryNames[i]+'" name="contact[province]" style="display: none;"><select class="custom-select" name="state" disabled' + (shouldBeRequired ? ' required' : '') +'><option value="">State / Province' + (shouldBeRequired ? '*' : '') +'</option>';
        var provincesNames = Object.keys(countryProps[i].provinces);
        for(var j in provincesNames) {
          output += '<option value="'+provincesNames[j]+'">'+provincesNames[j]+'</option>'
        }
        output += '</select></div>';
        $('.form-group-provinces').append(output);
      }
    }

    $('#select-country-generated').on('change', function() {
      // console.log($(this).val());
      $('.form-group-provinces > *').hide();
      if($('.select-wrapper[data-country="'+$(this).val()+'"]').length) {

        $('.form-group-provinces > input').prop('disabled', true).removeAttr('name');

        $('.sf-state').attr('name', 'state');

        $('.select-wrapper[data-country="'+$(this).val()+'"] select').prop('disabled', false);

        $('.select-wrapper[data-country="'+$(this).val()+'"]').show();  

        // var customSelect = $('.form-group-provinces .select-wrapper[data-country="'+$(this).val()+'"] .custom-select');
        // if(customSelect.length) {
        //   var $dropdownParent2 = $(customSelect).closest('.select-wrapper');
        //   customSelect.select2({
        //     minimumResultsForSearch: -1,
        //     dropdownParent: $dropdownParent2
        //   });
        // }
console.log('>>>>>>>> 1', $(this).val())
        var customSelect = $('.form-group-provinces .select-wrapper[data-country="'+$(this).val()+'"] .custom-select');
        if(customSelect.length) {
          var $dropdownParent2 = $(customSelect).closest('.select-wrapper');
          customSelect.select2({
            //minimumResultsForSearch: -1,
            dropdownParent: $dropdownParent2,
          matcher: matchStart
          });
          console.log('>>>>>>>> 2')
        }

      } else {
          $('.form-group-provinces select').prop('disabled', true);

          $('.sf-state').removeAttr('name');

          $('.form-group-provinces > input').show();

          $('.form-group-provinces > input').prop('disabled', false).attr('name', 'state');
        }
      
    });
  }


  if($('#select-country-generated-inq').length) {
    var countryNames = Object.keys(Countries)
    var countryProps = Object.values(Countries)
    for(var i in countryNames) {
      // console.log(countryNames[i]);
      $('#select-country-generated-inq').append('<option value="'+countryNames[i]+'">'+countryNames[i]+'</option>');

      if(countryProps[i].provinces) {
        // console.log('provinces for: ', countryNames[i]);
        var output = '<div class="select-wrapper" data-country="'+countryNames[i]+'" name="contact[province]" style="display: none;"><select class="custom-select" name="state" disabled><option value="">State / Province</option>';
        var provincesNames = Object.keys(countryProps[i].provinces);
        for(var j in provincesNames) {
          output += '<option value="'+provincesNames[j]+'">'+provincesNames[j]+'</option>'
        }
        output += '</select></div>';
        $('.form-group-provinces-inq').append(output);
      }
    }

    $('#select-country-generated-inq').on('change', function() {
      // console.log($(this).val());
      $('.form-group-provinces-inq > *').hide();
      if($('.select-wrapper[data-country="'+$(this).val()+'"]').length) {

        $('.form-group-provinces-inq > input').prop('disabled', true);

        $('.select-wrapper[data-country="'+$(this).val()+'"] select').prop('disabled', false);

        $('.select-wrapper[data-country="'+$(this).val()+'"]').show();  

        var customSelect = $('.form-group-provinces-inq .select-wrapper[data-country="'+$(this).val()+'"] .custom-select');
        if(customSelect.length) {
          var $dropdownParent2 = $(customSelect).closest('.select-wrapper');
          customSelect.select2({
            //minimumResultsForSearch: -1,
            dropdownParent: $dropdownParent2,
          matcher: matchStart
          });
        }
      } else {
$('.form-group-provinces-inq select').prop('disabled', true);
        $('.form-group-provinces-inq > input').show();

        $('.form-group-provinces-inq > input').prop('disabled', false);
      }
      
    });

    $('.inquiry-form-pdp').on('submit', function() {

      $('.inquiry-form-pdp input[type="text"]').not('.form-control-email').not('.form-control-freetext').each(function() {
        $(this).val($(this).val().toLowerCase().toTitleCase());
      });
      $('.form-control-email').each(function() {
        $(this).val($(this).val().toLowerCase());
      });
      $('.form-control-uppercase').each(function() {
        $(this).val($(this).val().toUpperCase());
      });
      $('.form-control-freetext').each(function() {
        $(this).val($(this).val().toSentenceCase());
      });
    });
  }

  $('.trade-form-pdp').on('submit', function() {
    $('.trade-form-pdp input[type="text"]').not('.form-control-email').not('.form-control-freetext').each(function() {
      // $(this).val(toSentenceCase($(this).val()));
      $(this).val($(this).val().toLowerCase().toTitleCase());
    });
      $('.form-control-email').each(function() {
        $(this).val($(this).val().toLowerCase());
      });
      $('.form-control-uppercase').each(function() {
        $(this).val($(this).val().toUpperCase());
      });
      $('.form-control-freetext').each(function() {
        $(this).val($(this).val().toSentenceCase());
      });
  });

  $('.gallery-form-pdp').on('submit', function() {
    $('.gallery-form-pdp input[type="text"]').not('.form-control-email').not('.form-control-freetext').each(function() {
      $(this).val($(this).val().toLowerCase().toTitleCase());
    });
      $('.form-control-email').each(function() {
        $(this).val($(this).val().toLowerCase());
      });
      $('.form-control-uppercase').each(function() {
        $(this).val($(this).val().toUpperCase());
      });
      $('.form-control-freetext').each(function() {
        $(this).val($(this).val().toSentenceCase());
      });
  });

  $(document).on('focus', '.select2-selection.select2-selection--single', function (e) {
    $(this).closest(".select2-container").siblings('select:enabled').select2('open');
  });

  // steal focus during close - only capture once and stop propogation
  $('select.select2').on('select2:closing', function (e) {
    $(e.target).data("select2").$selection.one('focus focusin', function (e) {
      e.stopPropagation();
    });
  });

  if(location.search == '?success=form-thank-you') {
    if(location.href.indexOf('trade') > -1) {
      $('.inquiry-success-message').text('THANK YOU FOR YOUR SUBMISSION. YOU WILL RECEIVE A REPLY FROM OUR TEAM WITHIN TWO BUSINESS DAYS.')
      $('#inquiry-modal').show();
      $('.popup-general__content form, .popup-inquiry-header').show();
      $('.popup-general__content form, .popup-inquiry-header').hide();
      $('.inquiry-success-message').show();
    }
    if(location.href.indexOf('product') > -1) {
      $('.inquiry-success-message').text('THANK YOU FOR YOUR INQUIRY. YOU WILL RECEIVE A REPLY FROM OUR TEAM WITHIN TWO BUSINESS DAYS.')
      $('#inquiry-modal').show();
      $('#inquiry-modal').addClass('thanks');
      $('.popup-general__content form, .popup-inquiry-header').show();
      $('.popup-general__content form, .popup-inquiry-header').hide();
      $('.inquiry-success-message').show();
    }
    if(location.href.indexOf('gallery') > -1) {
      $('#inquiry-modal').show();
      $('.popup-general__content form, .popup-inquiry-header').show();
      $('.popup-general__content form, .popup-inquiry-header').hide();
      $('.inquiry-success-message').show();
    }
    if(location.href.indexOf('expedited') > -1) {
      $('.inquiry-success-message').text('THANK YOU FOR YOUR INQUIRY. YOU WILL RECEIVE A REPLY FROM OUR TEAM WITHIN TWO BUSINESS DAYS.')
      $('#inquiry-modal').show();
      $('#inquiry-modal').addClass('thanks');
      $('.popup-general__content form, .popup-inquiry-header').show();
      $('.popup-general__content form, .popup-inquiry-header').hide();
      $('.inquiry-success-message').show();
    }

  }
})

String.prototype.toSentenceCase = function () {
  return this.toLowerCase().charAt(0).toUpperCase() + this.toLowerCase().slice(1);
}

function matchStart(params, data) {
  // If there are no search terms, return all of the data
  if ($.trim(params.term) === '') {
    return data;
  }


    // Do not display the item if there is no 'text' property
    if (typeof data.text === 'undefined') {
      return null;
    }

console.log(data.text.toLowerCase(), params.term.toLowerCase())

    // `params.term` should be the term that is used for searching
    // `data.text` is the text that is displayed for the data object
    if (data.text.toLowerCase().startsWith(params.term.toLowerCase())) {
      var modifiedData = $.extend({}, data, true);
      modifiedData.text += '';

      // You can return modified objects from here
      // This includes matching the `children` how you want in nested data sets
      return modifiedData;
    }

  // Return `null` if the term should not be displayed
  return null;
}

String.prototype.toTitleCase = function () {
  'use strict'
  var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|v.?|vs.?|via)$/i
  var alphanumericPattern = /([A-Za-z0-9\u00C0-\u00FF])/
  var wordSeparators = /([ :–—-])/

  return this.split(wordSeparators)
    .map(function (current, index, array) {
      if (
        /* Check for small words */
        current.search(smallWords) > -1 &&
        /* Skip first and last word */
        index !== 0 &&
        index !== array.length - 1 &&
        /* Ignore title end and subtitle start */
        array[index - 3] !== ':' &&
        array[index + 1] !== ':' &&
        /* Ignore small words that start a hyphenated phrase */
        (array[index + 1] !== '-' ||
          (array[index - 1] === '-' && array[index + 1] === '-'))
      ) {
        return current.toLowerCase()
      }

      /* Ignore intentional capitalization */
      if (current.substr(1).search(/[A-Z]|\../) > -1) {
        return current
      }

      /* Ignore URLs */
      if (array[index + 1] === ':' && array[index + 2] !== '') {
        return current
      }

      /* Capitalize the first letter */
      return current.replace(alphanumericPattern, function (match) {
        return match.toUpperCase()
      })
    })
    .join('')
}

// uk vs us
$(document).ready(function() {
  if($('.tear-us').length) {
    console.log('two sites');
    if(window.location.href.indexOf('.com') > -1) {
      $('.tear-us').show();
    } else {
      $('.tear-uk').show();
    }
  }
});
